import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Advertisers() {
  const Users = [
    {
      id: '01',
      image: '/nutcracker-2022/ads/octanner.jpg',
      link: 'https://www.octannerjewelers.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'OC Tanner Jewelers',
      class: 'webFormat',
    },
    {
      id: '02',
      image: '/nutcracker-2022/ads/lhmiller-lincoln.jpg',
      link: 'https://www.larryhmillerlincolndraper.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Larry H Miller Lincoln Draper',
      class: 'webFormat',
    },
    {
      id: '03',
      image: '/nutcracker-2022/ads/loveland.jpg',
      link: 'https://thelivingplanet.com/events-and-camps/festival-of-the-seas/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Loveland Living Planet Aquarium',
      class: 'webFormat',
    },
    {
      id: '04',
      image: '/nutcracker-2022/ads/cache-valley.jpg',
      link: 'https://www.cachevalleybank.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Cache Valley Banking Co.',
      class: 'webFormat',
    },
    {
      id: '05',
      image: '/nutcracker-2022/ads/italian-graffiti.jpg',
      link: 'https://www.italiangraffiti.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Italian Graffiti',
      class: 'webFormat',
    },
    {
      id: '06',
      image: '/nutcracker-2022/ads/gallivan-center.jpg',
      link: 'http://www.thegallivancenter.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Gallivan Center',
      class: 'webFormat',
    },
    {
      id: '07',
      image: '/nutcracker-2022/ads/daynes-music.jpg',
      link: 'http://www.daynesmusic.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Daynes Music',
      class: 'webFormat',
    },
    {
      id: '08',
      image: '/nutcracker-2022/ads/harmons.jpg',
      link: 'http://www.harmonsgrocery.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Harmons Grocery',
      class: 'webFormat',
    },
    {
      id: '09',
      image: '/nutcracker-2022/ads/afcu.jpg',
      link: 'https://www.americafirst.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'America First Credit Union',
      class: 'webFormat',
    },
    {
      id: '10',
      image: '/nutcracker-2022/ads/tuacahn.jpg',
      link: 'https://www.tuacahn.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Tuacahn Amphitheatre',
      class: 'webFormat',
    },
    {
      id: '11',
      image: '/nutcracker-2022/ads/springville.jpg',
      link: 'http://www.smofa.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Springville Museum of Art',
      class: 'webFormat',
    },
    {
      id: '12',
      image: '/nutcracker-2022/ads/carden-school.jpg',
      link: 'https://www.cardenmemorialschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Carden Memorial School',
      class: 'webFormat',
    },
    {
      id: '13',
      image: '/nutcracker-2022/ads/western-nut.jpg',
      link: 'https://www.westernut.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Western Nut',
      class: 'webFormat',
    },
    {
      id: '14',
      image: '/nutcracker-2022/ads/dancing-moose.jpg',
      link: 'https://mydancingmoose.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Dancing Moose Montessori School',
      class: 'webFormat',
    },
    {
      id: '15',
      image: '/nutcracker-2022/ads/ptc.jpg',
      link: 'https://pioneertheatre.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Pioneer Theatre Company',
      class: 'webFormat',
    },
    {
      id: '16',
      image: '/nutcracker-2022/ads/shen-yun.jpg',
      link: 'https://shenyuncreations.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Shen Yun',
      class: 'webFormat',
    },
    {
      id: '17',
      image: '/nutcracker-2022/ads/trove.jpg',
      link: 'https://troveparkcity.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Trove Gallery',
      class: 'webFormat',
    },
    {
      id: '18',
      image: '/nutcracker-2022/ads/sugarhouse-madeleine.jpg',
      link: '#',
      alt: 'Sugar House Furniture and The Madeleine Choir School',
      class: 'webFormat',
    },

    {
      id: '19',
      image: '/nutcracker-2022/ads/bmw-murray.jpg',
      link: 'https://www.bmwutah.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'BMW of Utah',
      class: 'webFormat',
    },
    {
      id: '20',
      image: '/nutcracker-2022/ads/country-hill-eye-center.jpg',
      link: 'https://www.checdocs.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Country Hills Eye Center',
      class: 'webFormat',
    },
    {
      id: '21',
      image: '/nutcracker-2022/ads/classical89.jpg',
      link: 'https://www.classical89.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Classical 89',
      class: 'webFormat',
    },
    {
      id: '22',
      image: '/nutcracker-2022/ads/challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Challenger School',
      class: 'webFormat',
    },
    {
      id: '23',
      image: '/nutcracker-2022/ads/hamilton-park.jpg',
      link: 'https://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Hamilton Park Interiors',
      class: 'webFormat',
    },
    {
      id: '24',
      image: '/nutcracker-2022/ads/minky.jpg',
      link: 'http://www.minkycouture.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Minky Couture',
      class: 'webFormat',
    },
    {
      id: '25',
      image: '/nutcracker-2022/ads/ufo.jpg',
      link: 'https://www.utahfestival.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Utah Festival Opera',
      class: 'webFormat',
    },
    {
      id: '26',
      image: '/nutcracker-2022/ads/rc-willey.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'RC Willey',
      class: 'webFormat',
    },
    {
      id: '27',
      image: '/nutcracker-2022/ads/regency.jpg',
      link: 'http://www.regencyroyale.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Regency Royal',
      class: 'webFormat',
    },
    {
      id: '28',
      image: '/nutcracker-2022/ads/utah-food-bank.jpg',
      link: 'https://www.utahfoodbank.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Utah Food Bank',
      class: 'webFormat',
    },
    {
      id: '29',
      image: '/nutcracker-2022/ads/rubys-inn.jpg',
      link: 'https://rubysinn.com/millsdec22',
      alt: 'Rubys Inn',
      class: 'webFormat',
    },
    {
      id: '30',
      image: '/nutcracker-2022/ads/u-first-credit.jpg',
      link: 'https://www.ufirstcu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'U First Credit Union',
      class: 'webFormat',
    },
    {
      id: '31',
      image: '/nutcracker-2022/ads/utah-school-dance.jpg',
      link: 'https://tickets.utah.edu/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'University of Utah Dance',
      class: 'webFormat',
    },
    {
      id: '32',
      image: '/nutcracker-2022/ads/werners.jpg',
      link: 'https://wernersmercedes.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Werners',
      class: 'webFormat',
    },
    {
      id: '33',
      image: '/nutcracker-2022/ads/adibs.jpg',
      link: 'https://adibs.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Adib’s Rug Gallery',
      class: 'webFormat',
    },
  ];

  Users.sort((a, b) => a.alt.localeCompare(b.alt));

  return (
    <div>
      {Users.map((data) => (
        <details key={data.id}>
          <summary>{data.alt}</summary>
          <OutboundLink
            href={data.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={data.image} alt={data.alt} className={data.class} />
          </OutboundLink>
        </details>
      ))}
    </div>
  );
}

export default Advertisers;
